import React from "react";
import { withAuthentication } from "@/hoc/withAuthentication";
import { Redirect } from "react-router";

const AccountantRestrictedRoute = ({ pathname = "/multi-manager", children, user }) => {
  return /accountant/i.test(user.type) ? <Redirect to={pathname} /> : <React.Fragment>{children}</React.Fragment>;
};

export default withAuthentication(AccountantRestrictedRoute);
